<div class="main-panel">
  <app-header></app-header>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <router-outlet></router-outlet> 
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
